import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-interval-combo-settings',
    templateUrl: './interval-combo-settings.component.html',
    styleUrls: ['./interval-combo-settings.component.scss']
})
export class IntervalComboSettingsComponent implements OnInit {

    @Input() moduleManager: ModuleManager;

    BreakdownMode = false;
    ListByInterval = true;

    constructor() { }

    ngOnInit(): void {
        this.moduleManager.addSetting({
            name: 'BreakdownMode',
            getValue: () => this.BreakdownMode,
            onSettingLoaded: value => this.BreakdownMode = value,
            defaultValue: false
        });

        this.moduleManager.addSetting({
            name: 'ListByInterval',
            getValue: () => this.ListByInterval,
            onSettingLoaded: value => this.ListByInterval = value,
            defaultValue: true
        });

        this.moduleManager.customSettingsAdded = true;
    }

}
